import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicationInformationDetails from './AppicationInformationDetails';
import HouseholdIncomeDetails from './HouseholdIncomeDetails';
import PropertyInformationDetails from './PropertyInformationDetails';

export const MDPAApplicationDetails = ({ applicationData }: IApplicationDetails) => {
  return (
    <>
      <ApplicationInformationDetails applicationInformation={applicationData.application} />
      <HouseholdIncomeDetails householdIncome={applicationData?.householdIncome} />
      <PropertyInformationDetails propertyInformation={applicationData.propertyInformation} />
    </>
  );
};
